import Const from '@/config/const'

export default {
  apiBaseUrl: process.env.VUE_APP_API_BASE_URL,
  // apiBaseUrl: 'http://10.0.10.61:8080',
  ...Const,
}
